import { EditOutlined } from '@ant-design/icons';
import { Button, Col, Form, Popconfirm, Row, Table, Tag } from 'antd';
import moment from 'moment';
import React from 'react';
import { useTranslation } from 'react-i18next';
import colorsDark from '../../../../assets/colors/dark';
import FormCustom from '../../../../components/FormCustom';
import { sortFieldsByPriority } from '../../utils.js';

const SettingPerAccount = ({
  keyTable,
  accountsActive,
  formExpandAccount,
  onFinishPerAccount,
  initialPerAccount,
  service,
  checkUpdatePerAccount,
  setCheckUpdatePerAccount,
  setKeyTable,
  expKeysAccount,
  setExpKeysAccount,
  handleTableChangeAccountActive,
  isLoadActiveLicenseAccount,
}) => {
  const { t } = useTranslation();

  const parsedConfig = React.useMemo(() => {
    if (!service?.configurationInput) return null;
    try {
      return JSON.parse(service.configurationInput);
    } catch {
      return null;
    }
  }, [service?.configurationInput]);

  const hasPerAccount = parsedConfig?.perAccount?.length > 0;
  if (!hasPerAccount) return null;

  const dataSource =
    accountsActive?.data?.map((device) => ({
      ...device,
      key: device.accountId,
    })) ?? [];

  return (
    <Col span={16}>
      <Table
        key={keyTable}
        dataSource={dataSource}
        expandable={{
          expandedRowRender: (record) => (
            <Form
              form={formExpandAccount}
              name="register-service"
              layout="vertical"
              onFinish={(value) => onFinishPerAccount(value, record)}
              initialValues={
                (record?.service?.configuration &&
                  JSON.parse(record?.service?.configuration)) ??
                initialPerAccount ??
                {}
              }
            >
              {parsedConfig?.perAccount?.length > 0 && (
                <Row gutter={32} style={{ width: '100%' }}>
                  {sortFieldsByPriority(parsedConfig?.perAccount).map(
                    (item, index) => (
                      <FormCustom
                        key={index}
                        spanLayout={
                          item?.type === 'period-minute' ? 10 : 12
                        }
                        data={item}
                        dataSerial={record}
                        formExpand={formExpandAccount}
                        disabled={checkUpdatePerAccount}
                      />
                    )
                  )}
                  <Col span={24}>
                    <Form.Item
                      style={{
                        width: '100%',
                      }}
                    >
                      <Button
                        disabled={checkUpdatePerAccount}
                        type="primary"
                        htmlType="submit"
                      >
                        {t('Update')}
                      </Button>
                      <Popconfirm
                        placement="top"
                        title={t('Are you sure？')}
                        okText={t('Yes')}
                        onConfirm={() => {
                          setKeyTable(Math.random());
                          const dataConfigurationTemp =
                            record?.service?.configuration &&
                            JSON.parse(record?.service?.configuration);
                          formExpandAccount.setFieldsValue(
                            dataConfigurationTemp &&
                              Object.keys(dataConfigurationTemp).length > 0
                              ? dataConfigurationTemp
                              : initialPerAccount ?? {}
                          );
                        }}
                        cancelText={t('No')}
                      >
                        <Button
                          disabled={checkUpdatePerAccount}
                          style={{ marginLeft: '10px' }}
                        >
                          {t('Restore')}
                        </Button>
                      </Popconfirm>
                    </Form.Item>
                  </Col>
                </Row>
              )}
            </Form>
          ),
        }}
        expandedRowKeys={expKeysAccount}
        onExpand={(check, record) => {
          setExpKeysAccount(check ? [record?.accountId] : []);
          setKeyTable(Math.random());
          setCheckUpdatePerAccount(true);
          const dataConfigurationTemp =
            record?.service?.configuration &&
            JSON.parse(record?.service?.configuration);
          formExpandAccount.setFieldsValue(
            dataConfigurationTemp &&
              Object.keys(dataConfigurationTemp).length > 0
              ? dataConfigurationTemp
              : initialPerAccount ?? {}
          );
        }}
        pagination={accountsActive && accountsActive.pagination}
        loading={accountsActive && accountsActive.loading}
        onChange={handleTableChangeAccountActive}
        columns={[
          {
            title: t('Full name'),
            dataIndex: 'fullName',
            key: 'fullname_account',
            sorter: (a, b) => (a.fullName ?? '').localeCompare(b.fullName ?? ''),
          },
          {
            title: t('Name'),
            dataIndex: 'userName',
            key: 'username_account',
            sorter: (a, b) => (a.userName ?? '').localeCompare(b.userName ?? ''),
          },
          {
            title: t('State'),
            key: 'log_action',
            width: 200,
            render: (account) =>
              isLoadActiveLicenseAccount.some(
                (id) => id === account.accountId
              ) ? (
                <Tag
                  style={{ width: 120, textAlign: 'center' }}
                  color={colorsDark.$warning}
                >
                  {t('Activating')}
                </Tag>
              ) : account.service ? (
                <Tag
                  style={{ width: 120, textAlign: 'center' }}
                  color={colorsDark.$online}
                >
                  {t('Activated')}
                </Tag>
              ) : (
                <Tag
                  style={{ width: 120, textAlign: 'center' }}
                  color={colorsDark.$offline}
                >
                  {t('Not activated')}
                </Tag>
              ),
          },
          {
            title: t('Active date'),
            key: 'log_activatedAt',
            dataIndex: 'service',
            sorter: (a, b) =>
              a.service?.activatedAt?.localeCompare(b.service?.activatedAt),
            render: (service) =>
              service?.activatedAt
                ? moment(service.activatedAt).format('DD-MM-YYYY')
                : '',
          },
          {
            title: t('License Code'),
            key: 'service_license_code_device',
            dataIndex: 'service',
            render: (service) =>
              service?.licenseCode ? service?.licenseCode : '',
          },
          {
            title: t('License Info'),
            key: 'service_license_info_device',
            dataIndex: 'service',
            render: (service) =>
              service?.licenseInfo ? service?.licenseInfo : '',
          },
          {
            title: t('Action'),
            key: 'actions ',
            render: (record) => (
              <div className="manager-member-actions">
                <div
                  className="edit-button"
                  style={{ cursor: 'pointer' }}
                  onClick={() => {
                    setExpKeysAccount([record?.accountId]);
                    setKeyTable(Math.random());
                    setCheckUpdatePerAccount(false);
                    const dataConfigurationTemp =
                      record?.service?.configuration &&
                      JSON.parse(record?.service?.configuration);
                    formExpandAccount.setFieldsValue(
                      dataConfigurationTemp &&
                        Object.keys(dataConfigurationTemp).length > 0
                        ? dataConfigurationTemp
                        : initialPerAccount ?? {}
                    );
                  }}
                >
                  <EditOutlined /> {t('Edit')}
                </div>
              </div>
            ),
          },
        ]}
      />
    </Col>
  );
};

export default SettingPerAccount;
